/* import __COLOCATED_TEMPLATE__ from './fly-blankslate.hbs.js'; */
import Component from '@glimmer/component';
export default class FlyBlankslate extends Component {
  get icon() {
    return this.args.icon ?? 'error';
  }
  get iconFill() {
    return this.args.iconFill ?? 'muted';
  }
  get iconSize() {
    return this.args.iconSize ?? 'lg';
  }
  get contentClassNames() {
    return this.args.contentClassNames ?? 'px-1.5 py-6';
  }
  get titleClassNames() {
    return this.args.titleClassNames ?? 'text-muted';
  }
}